import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'app/data.service';

@Component({
  selector: 'app-view-municipalities',
  templateUrl: './view-municipalities.component.html',
  styleUrls: ['./view-municipalities.component.css']
})
export class ViewMunicipalitiesComponent implements OnInit {

	municipalitiesData:any[];
	municipalityName: string;
	municipalityIndex: number;
	municipalityId: number;
	districtsData: any[];
	status: boolean;
	response: string;

  constructor(private dataService : DataService) { }

  municipalityData: FormGroup = new FormGroup({
   	municipality: new FormControl('', [Validators.required]),
    district: new FormControl('',[Validators.required])
  })

  ngOnInit(): void {
  	this.dataService.municipalities()
		.subscribe((municipalities:any) => {
			this.municipalitiesData = municipalities.municipalities;
  	});

  	this.dataService.districts()
		.subscribe((districts:any) => {
  			this.districtsData = districts.districts;
  	})
  }

  formValue(municipality, index){
	this.municipalityData.setValue({ municipality: municipality.municipality, district: municipality.District.id })
  	this.municipalityName = municipality.municipality;
  	this.municipalityId = municipality.id;
  	this.municipalityIndex = index;
  }

  editMunicipalityData(value){
  	if(this.municipalityData.valid){
		value['district'] = value['district'].toString()
  		this.dataService.editMunicipality(value,this.municipalityId)
      .subscribe( (response:any) => {
      	if(response.status){
      		this.response = response.message;
			this.status = response.status;
			response.municipality['District'] = this.districtsData.find(district => district.id == response.municipality.district_id)  
      		this.municipalitiesData.splice(this.municipalityIndex, 1, response.municipality);
      	}
      	else{
      		this.response = response.message;
      		this.status = response.status
      	}
      });
  	}
  	else{
  		this.response = "Please Fill All The Update Values or Change Them";
    	this.status = false;
  	}
  }

  scroll(el:HTMLElement){
  	el.scrollIntoView();
  }

}
